module.exports = __webpack_public_path__ + "static/img/14.7847f23.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/14.png
// module id = axMT
// module chunks = 4